import _ from 'lodash';

import { ACTIONS, CONSTANTS } from '../config/constants';

// TODO Handle errors and dispatch (for all actions)
// TODO Monitor performance as QQ and QQO tables grow, if needed separate
export function createQuiz(
  tags,
  examTags,
  count,
  mode,
  trial,
  questions,
  altInit
) {
  return (dispatch, getState) => {
    dispatch({ type: ACTIONS.TYPES.QUESTION.GET_INITIALIZED });

    return (!trial
      ? ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
          `${ACTIONS.JSON_API_PATH}/_createQuiz/`,
          {
            headers: {
              Authorization: `Bearer ${
                process.env.REACT_APP_MOBILE_TEST
                  ? 'MOBILE_TEST_AUTH'
                  : getState().auth.accessToken
              }`
            },
            params: {
              tags: tags.length ? tags : getState().tags.map(t => t.id),
              examTags: examTags.length
                ? examTags
                : getState().examTags.map(t => t.id),
              count,
              mode: CONSTANTS.MODE[mode.toUpperCase()],
              product: getState().app.product,
              questions
            }
          }
        )
      : ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
          `${ACTIONS.JSON_API_PATH}/_createQuiz/`,
          {
            headers: {
              Authorization: `Bearer ${
                process.env.REACT_APP_MOBILE_TEST
                  ? 'MOBILE_TEST_AUTH'
                  : getState().auth.accessToken
              }`
            },
            params: {
              tags: tags.length ? tags : getState().tags.map(t => t.id),
              examTags: null,
              count,
              mode: CONSTANTS.MODE[mode.toUpperCase()],
              product: getState().app.product,
              trial
            }
          }
        )
    )
      .then(res => {
        const quiz = res.data.data[0].attributes.quiz;
        if (!questions && !altInit && quiz.questions.length < 5) {
          dispatch({
            type: ACTIONS.TYPES.QUIZ.INITIALIZE_ERROR,
            error: { error: true }
          });
        } else {
          quiz.currentQuestionIndex = 0;
          quiz.finished = false;
          quiz.viewOnly = false;
          quiz.questions.forEach(question => {
            Object.assign(question, {
              currentNotesValue: null,
              editingNotes: !!question.notes,
              explanationVisible: false,
              answered: false,
              selectedOptionIndex: -1,
              time: 0,
              images:
                question.images && question.images[0] ? question.images : []
            });
            question.options.forEach(option => {
              Object.assign(option, {
                explanationVisible: false
              });
            });

            question.options.map(o =>
              o.correct ? Object.assign(o, { correctOption: true }) : o
            );
          });
          dispatch({ type: ACTIONS.TYPES.QUIZ.INITIALIZE_SUCCESS, quiz });
        }
      })
      .catch(error =>
        dispatch({ type: ACTIONS.TYPES.QUESTION.GET_ERROR, error })
      );
  };
}

export function continueQuiz() {
  return (dispatch, getState) => {
    if (typeof getState().app.currentQuiz === 'object') {
      const quiz = _.cloneDeep(getState().app.currentQuiz);
      return new Promise(res =>
        res(dispatch({ type: ACTIONS.TYPES.QUIZ.INITIALIZE_SUCCESS, quiz }))
      );
    }
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_continueQuiz`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        },
        params: {
          quiz: getState().app.currentQuiz
        }
      }
    )
      .then(res => {
        const quiz = res.data.data[0].attributes.quiz;
        quiz.currentQuestionIndex = 0;
        quiz.finished = false;

        quiz.questions.forEach((question, index) => {
          Object.assign(question, {
            currentNotesValue: null,
            editingNotes: false,
            explanationVisible: false,
            images: question.images && question.images[0] ? question.images : []
          });
          question.options.forEach((option, optionIndex) => {
            Object.assign(option, {
              explanationVisible:
                optionIndex === question.selectedOption ||
                (question.answered && option.correctOption)
            });
          });
        });
        dispatch({ type: ACTIONS.TYPES.QUIZ.INITIALIZE_SUCCESS, quiz });
      })
      .catch(error =>
        dispatch({ type: ACTIONS.TYPES.QUESTION.GET_ERROR, error })
      );
  };
}

export function initViewOnlyQuiz(quiz) {
  return (dispatch, getState) => {
    return new Promise(res =>
      res(dispatch({ type: ACTIONS.TYPES.QUIZ.INITIALIZE_SUCCESS, quiz }))
    );
  };
}

/* Accepts multiple objects:
 * Use HELPERS.UPDATE_OBJECT([updateObject], [questionIndex](optional), [optionIndex](optional))
 * */
// TODO error handle
export function updateQuiz(...updates) {
  return (dispatch, getState) => {
    const quiz = _.cloneDeep(getState().quiz) || {};

    updates.forEach(update => {
      const { questionIndex, optionIndex, updateObject } = update;
      if (questionIndex !== undefined && optionIndex !== undefined) {
        Object.assign(
          quiz.questions[questionIndex].options[optionIndex],
          updateObject
        );
      } else if (questionIndex !== undefined) {
        Object.assign(quiz.questions[questionIndex], updateObject);
      } else {
        Object.assign(quiz, updateObject);
      }
    });
    return new Promise(res =>
      res(dispatch({ type: ACTIONS.TYPES.QUIZ.UPDATE_QUIZ, quiz }))
    );
  };
}

export function setCurrent() {
  return (dispatch, getState) => {
    if (getState().quiz && getState().quiz.viewOnly !== true) {
      const app = Object.assign(_.cloneDeep(getState().app), {
        currentQuiz: _.cloneDeep(getState().quiz)
      });
      return new Promise(res =>
        res(dispatch({ type: ACTIONS.TYPES.APP.UPDATE_APP, app }))
      );
    }
    return new Promise(res => res(dispatch({ type: null })));
  };
}



// WEBPACK FOOTER //
// ./src/actions/quiz.js